import * as Constants from './constants'

const initialState = {
  list: [],
  listHistory: [],
  item: {},
  type: Constants.GIAOHANG_REPORT_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {},
  callback: function () { },
}

const reducer = function giaoHangReportReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.GIAOHANG_REPORT_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.GIAOHANG_REPORT_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        listGiaoHang: action.data.records,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.GIAOHANG_REPORT_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.GIAOHANG_REPORT_LIST_NV_REQUESTING:
      return {
        ...state,
        type: action.type,
        messages: [],
        errors: [],
      }

    case Constants.GIAOHANG_REPORT_LIST_NV_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        messages: [],
        errors: [],
      }

    case Constants.GIAOHANG_REPORT_LIST_NV_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.GIAOHANG_REPORT_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.GIAOHANG_REPORT_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.GIAOHANG_REPORT_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Reports/GiaoHangReport/reducer.js